import React, { useState } from "react";
import styles from "./KnowledgeBasePopOver.module.css";
import CustomPopOver from "./CustomPopOver";
import { translate } from "../../providers";
import { CustomButton } from "../buttons";
import { IconComponent, icon } from "../icon-component";

const KnowledgeBasePopOver = ({ label, link, linkLabel, color = "var(--grey-600)", size = "md", children }) => {
	const [open, setOpen] = useState(false);
	const handleOpenInformationBox = () => {
		setOpen(true);
	};
	const handleCloseInformationBox = () => {
		setOpen(false);
	};
	return (
		<div
			className={styles.wrapper}
			role="presentation"
			onMouseEnter={handleOpenInformationBox}
			onMouseLeave={handleCloseInformationBox}
		>
			<CustomPopOver
				className={styles.information__content}
				content={
					<div>
						<div>{label}</div>
						{link && (
							<div className={styles["information__content--footer"]}>
								<CustomButton
									startIcon={icon.faUpRightFromSquare}
									variant="contained"
									onClick={() => {
										window.open(link, "_blank");
									}}
								>
									{linkLabel || translate("common:knowledge-base:access")}
								</CustomButton>
							</div>
						)}
					</div>
				}
				open={open}
				placement="bottom"
				onClose={handleCloseInformationBox}
			>
				{children || (
					<span role="presentation">
						<IconComponent color={color} icon={icon.faInfoCircle} size={size} />
					</span>
				)}
			</CustomPopOver>
		</div>
	);
};

export default KnowledgeBasePopOver;
